import React from "react";
import { useMutation } from "react-query";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import { toTitleCase } from "../../../../Utils/stringUtls";
import FilesUploadService from "../../../../Services/FilesUploadService";
import { createFileDownloadMutation } from "../reviewSummaryUtils";
import FileDownloadDisplay from "../Components/FileDownloadDisplay";

const SettlementAndReconciliationOverview = ({ data }) => {
  const downloadFileMutation = useMutation(
    createFileDownloadMutation(FilesUploadService)
  );

  const handleDownload = (fileName) => {
    downloadFileMutation.mutate(fileName);
  };

  if (!data) return <DataNotFound />;

  const {
    ov_nf_ssrp_for_manager,
    ov_nf_cut_off_time,
    ov_nf_pci_compliant,
    ov_nf_comp_cert,
  } = data["8_0"];

  return (
    <React.Fragment>
        <>
          <div className="forms-instance" style={{ color: "#111" }}>
            <div i2c-grid="grid grid" className="review-summary-gap">
              <div i2c-grid="12@md" className="review-summary-sub-heading">
                <div className="fw-700 font-bold">Nightly Files (SSRP)</div>
              </div>
              <ReviewAttribute
                label="Would program manager also require SSRP nightly files from i2c Inc?"
                value={
                  ov_nf_ssrp_for_manager?.length
                    ? toTitleCase(ov_nf_ssrp_for_manager)
                    : "-"
                }
              />
              <ReviewAttribute
                label="Preferred Cut Off Time"
                value={ov_nf_cut_off_time?.length ? ov_nf_cut_off_time : "-"}
              />
              <ReviewAttribute
                label="Are you PCI Compliant?"
                value={
                  ov_nf_pci_compliant?.length
                    ? toTitleCase(ov_nf_pci_compliant)
                    : "-"
                }
              />
              {ov_nf_pci_compliant === "yes" && ov_nf_comp_cert && (
                <FileDownloadDisplay
                  label="Compliance Certificate"
                  fileName={ov_nf_comp_cert}
                  onDownload={handleDownload}
                />
              )}
            </div>
          </div>
        </>
    </React.Fragment>
  );
};
export default SettlementAndReconciliationOverview;
